import { set } from "firebase/database";
import { React, useState, useEffect } from "react";
import { ReactComponent as ReactLogo1 } from "../assets/B1.svg";
import { ReactComponent as ReactLogo2 } from "../assets/Badge4.svg";
import { ReactComponent as ReactLogo3 } from "../assets/B_activated.svg";
import LockIcon from "../assets/lock.png";
import ModuleOne from "../assets/module-one.png";
import ModuleTwo from "../assets/module-two.png";

export default function Badge({ badge, num }) {
	const [displayBadge, setDisplayBadge] = useState(false);
	const [badgeImg, setBadgeImg] = useState();
	console.log(badgeImg);
	useEffect(() => {
		setDisplayBadge(badge.is_awarded);
		setBadgeImg(badge.img);
	}, [badge]);
	const handleClick1 = (curNum) => {
		const elementActive = document.getElementsByClassName("card-three")[curNum];
		const elementsHidden = document.getElementsByClassName("card-three");
		console.log(Object.values(elementsHidden));
		Object.values(elementsHidden).forEach((elementHidden, i) => {
			if (i !== curNum) {
				elementHidden.classList.add("disabled");
			}
		});
		elementActive.classList.contains("completed")
			? elementActive.classList.remove("completed")
			: elementActive.classList.remove("disabled");
	};

	return (
		<>
			<div className="badge" onClick={() => handleClick1(num)}>
				{displayBadge ? <img src={badgeImg} /> : <img src={LockIcon} />}
			</div>
		</>
	);
}
